/**
 * Pure selection logic behind the billing-address "use this" toggle in `paymentinfo.tsx`, pulled
 * out into its own module so it can be unit tested without mounting the whole signup page (which
 * pulls in Stripe/axios/webpack-alias-only imports on mount).
 *
 * Given the current (single-entry) billing-address array, applies a checked/unchecked toggle at
 * `index` and returns the resulting array plus whether anything ended up selected. When nothing is
 * selected afterwards (e.g. the sole address was just deselected), `selectedAddress` is undefined
 * and the caller is expected to fall back to billing via account info instead of indexing into it.
 */
export function computeBillingAddressSelection(
  currentAddresses: Array<any>,
  index: number,
  checkedStatus: boolean
): {addresses: Array<any>; containBilling: boolean; selectedAddress: any | undefined} {
  const tempTotalBilling: Array<any> = []
  let containStatus = false

  for (let i = 0; i < currentAddresses?.length; i++) {
    if (i === index) {
      if (checkedStatus === true) containStatus = true

      tempTotalBilling.push({
        ...currentAddresses[i],
        index: currentAddresses[index]?.index,
        useStatus: checkedStatus,
      })
    } else if (checkedStatus === true) {
      tempTotalBilling.push({...currentAddresses[i], useStatus: false})
    } else {
      if (currentAddresses[i]?.useStatus === true) containStatus = true

      tempTotalBilling.push(currentAddresses[i])
    }
  }

  const selectedAddress = tempTotalBilling.find((item: any) => item.useStatus === true)
  return {addresses: tempTotalBilling, containBilling: containStatus, selectedAddress}
}
